export const API_VERSION = "2025-07-16";
export const API_VERSION_HEADER_NAME = "x-trigger-api-version";
